module.exports = __webpack_public_path__ + "img/nt50-00-80-1_1.prt.6832ee39.jpg";